module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.fullScreen && (_vm.maskVisible || _vm.visible)) ? _c('div', {
    ref: "mask",
    class: _vm.maskContentClass
  }, [_c('transition', {
    attrs: {
      "name": "p-galleria"
    },
    on: {
      "enter": _vm.onEnter,
      "before-leave": _vm.onBeforeLeave,
      "after-leave": _vm.onAfterLeave,
      "appear": _vm.onAppear
    }
  }, [(_vm.visible) ? _c('GalleriaContent', _vm._b({
    attrs: {
      "templates": _vm.$scopedSlots
    },
    on: {
      "maskHide": _vm.maskHide,
      "activeItemChange": _vm.onActiveItemChange
    }
  }, 'GalleriaContent', _vm.$props, false)) : _vm._e()], 1)], 1) : (!_vm.fullScreen) ? _c('GalleriaContent', _vm._b({
    attrs: {
      "templates": _vm.$scopedSlots
    },
    on: {
      "activeItemChange": _vm.onActiveItemChange
    }
  }, 'GalleriaContent', _vm.$props, false)) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f0ef48a6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/primevue/galleria/Galleria.vue
// module id = 2436
// module chunks = 0